import React, { Component, PropTypes } from 'react';
import R from 'ramda';

const propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
  })),
  style: PropTypes.object,
  listItemStyle: PropTypes.object,
};
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
class ContactList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  toggleList = () => {
    this.setState({ expanded: !this.state.expanded });
  }
  render() {
    const arrLength = R.pathOr(0, ['users', 'length'], this.props);
    return (
      <div style={this.props.style}>
        {
          this.props.users.slice(0, this.state.expanded ? this.props.users.length : 3).map(user => (
            <small key={user.email} style={this.props.listItemStyle}>
                {user.name || `${user.firstName || ''} ${user.lastName || ''}`} {user.email}
            </small>
          ))
        }
        {
          arrLength > 3 ? (<a onClick={this.toggleList} style={{ cursor: 'pointer', fontSize: '10px', textDecoration: 'underline' }}>
            { this.state.expanded ? 'Show Less' : 'Show All' }
          </a>) : <div/>
        }
      </div>
    );
  }
}

ContactList.propTypes = propTypes;

export default ContactList;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/contactList.jsx